import React from "react";

// Import Styles
import "../styles/Work.css";

// Import Data
import Work01 from "../assets/images/work01.jpg";
import Work02 from "../assets/images/work02.jpg";
import Work03 from "../assets/images/work03.jpg";
import Work04 from "../assets/images/work04.jpg";

function Work() {
  return (
    <div className="Work">
      <div className="Work-Container">
        <div className="Work-Top-Container">
          <h1>Nuestro Trabajo</h1>
          <p>
            En Jowell's Barbershop queremos que ames tu experiencia en nuestra
            barbería por eso nos esforzamos en cada detalle.
          </p>
        </div>

        <div className="Work-Bottom-Container">
          <img src={Work01} alt="" />
          <img src={Work02} alt="" />
          <img src={Work03} alt="" />
          <img src={Work04} alt="" />
        </div>

        <div className="Card__button">
          {/* <button>
            <a href="../pages/Gallery.js">Ver más</a>
          </button> */}
        </div>
      </div>
    </div>
  );
}

export default Work;
